module.exports = __webpack_public_path__ + "static/media/抽象畫生成真實圖片.ba18efcf.png";